import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '../ui/dialog';
import { AuthForm } from './AuthForm';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  mode: 'login' | 'signup';
}

export function AuthModal({ isOpen, onClose, mode }: AuthModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogTitle className="text-center">
          {mode === 'login' ? 'Welcome Back' : 'Create Account'}
        </DialogTitle>
        <AuthForm mode={mode} onSuccess={onClose} />
      </DialogContent>
    </Dialog>
  );
}